import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'

const CardAmountSwatches = ({amounts, setSelectedAmount, selectedAmount}) => {
    const styles = useMultiStyleConfig('GiftCertificate')
    return (
        <Flex {...styles.rightBox.amountSwatches.main}>
            {amounts.map((amount) => (
                <Box
                    key={amount}
                    as="button"
                    onClick={() => setSelectedAmount(amount)}
                    background={selectedAmount === amount ? 'black.100' : 'gray.400'}
                    color={selectedAmount === amount ? 'white' : 'black.100'}
                    {...styles.rightBox.amountSwatches.swatch}
                >
                    ${amount}
                </Box>
            ))}
        </Flex>
    )
}

CardAmountSwatches.propTypes = {
    amounts: PropTypes.any,
    selectedAmount: PropTypes.any,
    setSelectedAmount: PropTypes.func
}

export default CardAmountSwatches
